export { default } from "./BoltIcon";
